<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>Account Verification
        <button type="button" class="close"
                @click.prevent="closeModal()">
          <span aria-hidden="true">&times;</span></button>
      </h5>
    </div>
    <b-form>
      <div class="container-fluid visit-charge-body">
        <div class="row mb-4">
          <div class="col-2">
          </div>
          <div class="col-8">
            To verify your account: 2 small deposits of less than $0.10 will be made.
          </div>
        </div>
        <div class="row">
          <div class="col-2">
          </div>
          <div class="col-8">
        Check back in 1-2 days when these charges clear the account and enter the amounts to complete verification.
          </div>
        </div>

        <div class="row m-2">
          <div class="col-3">
          </div>
          <div class="col-3">
            <b>Account Name</b>
            <br><b>Account Number</b>
          </div>
          <div class="col-3">
            {{account.name}}
            <br>{{account.last4}}
          </div>
        </div>
      </div>
    </b-form>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-orange float-right" @click.prevent="save()">
        <font-awesome-icon size="lg" class="mr-2" v-show="isSaving" icon="spinner" pulse/>
        Send Deposits
      </button>
      <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
    </div>
  </b-modal>

</template>

<script>
  import api from '@/services/api'
  import _ from 'lodash'

  export default {
    name: 'AccountNeedsVerificationModal.vue',

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      account: {
        type: Object,
        required: true
      },

      accountPayee: {
        type: Object,
        required: false
      },

      accountEmployer: {
        type: Object,
        required: false
      }
    },

    data () {
      return {
        payee: {
          organizationPayeeId: 0,
          firstName: '',
          lastName: ''
        },
        employer: {
          organizationEmployerId: 0,
          name: ''
        },
        isSaving: false
      }
    },

    watch: {
      accountPayee (newValue) {
        this.payee = _.clone(newValue)
      },

      accountEmployer (newValue) {
        this.payee = {
          organizationPayeeId: 0,
          firstName: '',
          lastName: ''
        }
        this.employer = _.clone(newValue)
      }
    },

    methods: {
      save () {
        if (this.isSaving) {
          return
        }

        this.isSaving = true
        let url = '/Dashboard/Employer/Accounts/StartVerification'
        if (this.payee.organizationPayeeId) {
          url = '/Dashboard/Payee/Accounts/StartVerification'
        }

        const request = {
          fundingSourceId: this.account.externalId
        }
        api.post(url, request).then(response => {
          this.isSaving = false
          this.$emit('accountVerificationStarted', false)
        }).catch(error => {
          this.isSaving = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
            this.$log.error('Error attempting to request payee verification: ' + error.message, error)
          }
        })
      },

      closeModal () {
        this.$emit('update:visible', false)
      }
    }
  }
</script>

<style scoped>

</style>
